<template>
    <Link :href="'/'">
        <img
            v-bind:src="'/musicologie-wordmark.webp'"
            style="max-width: 300px"
        />
    </Link>
</template>

<script>
import { Link } from "@inertiajs/vue2";

export default {
    components: { Link },
};
</script>
